"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
const __1 = require("..");
class WCAGOrganisationSearchField extends __1.WCAGSearchField {
    constructor(options) {
        super({
            ...options,
            minQueryLength: 1
        });
        this.suggestOracle = options?.suggestOracle;
    }
    format(suggestion) {
        const orgId = this.formatOrgId(suggestion);
        if (!suggestion.OrganisationName) {
            return { text: orgId || "ukendt navn" };
        }
        const organisationId = orgId ? "(" + orgId + ")" : "";
        const duplicateString = suggestion.IsDuplicate ? "(Dublet)" : "";
        return { text: `${suggestion.OrganisationName} ${organisationId} ${duplicateString}` };
    }
    async search(query) {
        if (query.length < this.getMinQueryLength()) {
            this.populateSuggestions([], false);
        }
        else {
            const response = await this.suggestOracle.requestSuggestions(query);
            this.populateSuggestions(response.suggestions || [], true, response.moreSuggestions);
        }
    }
    setSuggestOracle(suggestOracle) {
        this.suggestOracle = suggestOracle;
    }
    decorateWCAGSearchFieldElement(options) {
        if (options.tooltipTitle && options.tooltipBody) {
            const tooltipImg = new __1.ImageWidget({
                alt: options.tooltipBody,
                imageDimension: __1.ImageDimensions.M,
                tooltipWidth: options.tooltipWidth,
                imageSeverity: __1.ImageSeverity.INFO,
                src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.HELP),
                tooltip: async () => {
                    return {
                        bodyHtml: options.tooltipBody,
                        header: options.tooltipTitle
                    };
                }
            });
            this.labelElement.appendChild(tooltipImg.element);
        }
    }
    formatOrgId(value) {
        let orgId;
        let orgIdPrefix;
        if (value.OrganisationType) {
            switch (value.OrganisationType) {
                case "Doctor":
                    orgId = "" + value.DoctorOrganisationIdentifier;
                    orgIdPrefix = `${value.DoctorOrganisationSpecialityText?.toLowerCase()}, yder: `;
                    break;
                case "Hospital":
                    orgId = value.HospitalOrganisationIdentifier;
                    orgIdPrefix = "sks: ";
                    break;
                case "Municipality":
                    orgId = "" + value.MunicipalityOrganisationIdentifier;
                    orgIdPrefix = "kommune: ";
                    break;
                case "Pharmacy":
                    const typesAndIds = [];
                    if (value.PharmacyIdentifier) {
                        typesAndIds.push("apotek: " + value.PharmacyIdentifier);
                    }
                    if (value.EANLocationIdentifier) {
                        typesAndIds.push("ean: " + value.EANLocationIdentifier);
                    }
                    return typesAndIds.join(", ");
                case "SOR":
                    orgId = `${value.SorId}`;
                    orgIdPrefix = `${value.SorType}, sor: `;
                    break;
            }
        }
        return orgIdPrefix + orgId;
    }
}
exports.default = WCAGOrganisationSearchField;
//# sourceMappingURL=WCAGOrganisationSearchField.js.map